// extracted by mini-css-extract-plugin
export default {"button":"ReservationCompletePage_button__3tRCh","content":"ReservationCompletePage_content__md7zu","procedure":"ReservationCompletePage_procedure__XBhjv"};